module.exports = __webpack_public_path__ + "static/media/Avatars_Male-27.e03b928b.png";